import { Mail } from 'lucide-react'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { Button } from 'src/shared/components/ui'
import { Badge } from 'src/shared/components/ui/badge'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const CheckEmailSuccess = ({
  email,
  onUseDifferentEmail,
}: {
  email: string
  onUseDifferentEmail: () => void
}) => {
  const { t } = useLocalization()

  return (
    <Column className="gap-5">
      <Column className="gap-2">
        <h1>{t('Check your email', 'Kolla din e-post')}</h1>
        <p>
          {t(
            'We sent a magic link to the address below. Open it to log in to your account.',
            'Vi skickade en magisk länk till adressen nedan. Öppna den för att logga in på ditt konto.'
          )}
        </p>
        <Badge variant="glass" size="lg" className="w-fit">
          <Mail className="mr-1.5 h-4 w-4 text-muted-foreground" />
          {email}
        </Badge>
      </Column>

      <Row className="card-inner p-3 text-sm text-muted-foreground">
        <span>
          {t(
            'Did not get an email? Check spam or try again in a few minutes.',
            'Fick du inget mejl? Kolla skräpposten eller försök igen om en stund.'
          )}
        </span>
      </Row>

      <Button
        type="button"
        variant="secondary"
        className="w-full"
        size="lg"
        onClick={onUseDifferentEmail}
      >
        {t('Use a different email', 'Använd en annan e-postadress')}
      </Button>
    </Column>
  )
}
